import React, { useEffect } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { MessageMsgFrom, MessageType } from '@tencent/dz-models';
import { UIButton } from '@tencent/dz-bricks-ui';
import { useConsultModel, useMobileModel, useMessageModel } from '../../../hooks';
import { MenuItemType } from '../../../const';
import { useReportService } from './useReportService';
import styles from './style/index.less';
export var BlockConsultMenu = function () {
    var consultModel = useConsultModel();
    var consult = consultModel.consult, isFullSearch = consultModel.isFullSearch;
    var View = useComponents().View;
    var messageModel = useMessageModel();
    var mobileModel = useMobileModel();
    var consultMenu = consult.consult_menu;
    var enableMenu = consultModel.getConsultConfig().menu_enable;
    var quickConsultContent = consultMenu.map(function (item) { return item.item_title; }).join(',');
    var report = useReportService(quickConsultContent);
    if (!isFullSearch()) {
        // 非全屏咨询页，不需要去官网类型的自助咨询
        consultMenu = consultMenu.filter(function (item) { return item.item_type !== MenuItemType.goWeb; });
    }
    useEffect(function () {
        if (enableMenu !== 0 && consultMenu && consultMenu.length > 0) {
            report.menuExposure();
        }
    }, []);
    var handleMenuClick = function (menu, index) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var item_type = menu.item_type, item_content = menu.item_content, item_title = menu.item_title;
        switch (item_type) {
            case MenuItemType.phone:
                // 拨打电话
                mobileModel.callByComponentId(item_content);
                break;
            case MenuItemType.consult:
                // 快捷回复
                messageModel.pushMessage({
                    type: MessageType.Server,
                    msg_from: MessageMsgFrom.Server,
                    payload: {
                        message: item_content,
                    },
                });
                break;
            case MenuItemType.form:
                // 表单
                if (consultModel.isSearchConsult()) {
                    messageModel.pushFormMessage(MessageType.SelfConsultForm, { source: report.moduleParams });
                }
                else {
                    messageModel.pushFormMessage(MessageType.FormOrder, { source: report.moduleParams, title: item_title });
                }
                break;
            case MenuItemType.goWeb:
                // 去官网
                consultModel.transferMessage(JSON.stringify({
                    type: 'jump',
                    url: item_content,
                }), function () { return (window.location.href = item_content); });
                break;
            default:
                break;
        }
        report.menuClick({ menu: menu, index: index });
    };
    if (enableMenu === 0 || !consultMenu || consultMenu.length === 0) {
        return null;
    }
    return (React.createElement(View, { className: styles['chat-menu-container'] },
        React.createElement(View, { className: styles['search-chat-menu'] }, consultMenu.map(function (menu, index) { return (React.createElement(UIButton, { key: menu.item_id, type: menu.item_type === 1 ? 'tel' : 'button', className: styles['search-chat-menu-item'], onClick: function () { return handleMenuClick(menu, index); } }, menu.item_title)); }))));
};
